import type {Command, EditorView} from '@codemirror/view'

import {MarkdownLine} from '../../../language-tools/markdown/markdown-line'
import {getMarkdownTree} from '../../extensions/markdown-parser'
import {dedentSelectedListItems} from './dedent-selected-items'

/** If a single cursor is in a blank list item, dedent or remove that list item. */
export const dedentListIfBlankItem: Command = (view: EditorView) => {
  if (view.state.selection.ranges.length !== 1 || !view.state.selection.main.empty) return false

  const source = view.state.doc.toString()
  const caretPosition = view.state.selection.main.anchor
  const tree = getMarkdownTree(view.state)

  const line = MarkdownLine.atOffset(tree, source, caretPosition)
  if (!line || !isCaretInBlankListItem(line, caretPosition)) return false

  return dedentSelectedListItems(view)
}

const isCaretInBlankListItem = (line: MarkdownLine, caretOffset: number) => {
  if (!line.isBlank) return false

  if (line.lastPrefix?.tokenType !== 'listItemPrefix') return false

  return line.isOffsetAfterPrefixes(caretOffset)
}
